import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonTagsComponent } from './button-tags/button-tags.component'

const DECLARES = [
    ButtonTagsComponent,
]

@NgModule({
    providers: [],
    imports: [
        CommonModule,
    ],
    exports: [
        ...DECLARES,
    ],
    declarations: [...DECLARES],
})
export class OButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/commons/o-button/o-button.module.ts